export const blockIconsImageReceiptLong = (
	<span className='material-symbols-outlined'>receipt_long</span>
);
